// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Createdatafactoryupdate/styles.css
// module id = 1920
// module chunks = 193